import { render, staticRenderFns } from "./ChurnData.container.vue?vue&type=template&id=3d8c0055&"
import script from "./ChurnData.container.vue?vue&type=script&lang=ts&"
export * from "./ChurnData.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports